// Constants
import { ERROR, ERROR_VERIFY } from '../constants/contract-otp.constants';
// Services
import {
  getOtpStateService,
  requestNewCodeService,
  verifyCodeService,
} from '../services/contract-otp.services';
// Types
import {
  GetOtpStateResolverType,
  RequestNewCodeResolverType,
  VerifyCodeResolverReturnType,
  VerifyCodeResolverType,
} from './types/contract-otp.resolver.types';
// Utilities
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';
import { getVerifyOtpError } from './utils/contract-otp.resolver.utils';

const getOtpStateResolver = async (): GetOtpStateResolverType => {
  const [response, { status }] = await getOtpStateService();
  return requestHasSuccessStatus(status) ? [response, false] : [null, true];
};

const requestNewCodeResolver = async (): RequestNewCodeResolverType => {
  const [{ errorCode = '' }, { status }] = await requestNewCodeService();
  return requestHasSuccessStatus(status) ? [null, false] : [errorCode, true];
};

const verifyCodeResolver = async ({
  otpId,
  otpValue,
}: VerifyCodeResolverType): VerifyCodeResolverReturnType => {
  const [{ errorCode = '' }, { status }] = await verifyCodeService({ otpId, otpValue });
  return requestHasSuccessStatus(status)
    ? [null, false]
    : [getVerifyOtpError({ errorCode, status }), true];
};

export { getOtpStateResolver, requestNewCodeResolver, verifyCodeResolver };
